class CommonCart {
  constructor() {
    this.toastTimeout = 3000;
  }

  async addToCart(button, variantId, quantity) {
    try {
      // button
      button.classList.add('loading');

      // Get CSRF token from meta tag
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
        .then(response => response.json())
        .then(data => {
          // Success - update mini cart or show confirmation
          button.classList.remove('loading');
          button.classList.add('added');
          // Update cart sidebar
          const cartSidebar = document.querySelector('cart-sidebar');
          cartSidebar.updateCart();
          // cartSidebar.openCart();

          setTimeout(() => {
            button.classList.remove('added');
          }, 2000);
          return data;
        })
        .catch((error) => {
          console.error('Error:', error);
          button.classList.remove('loading');
        });

      if (res.status == 422) {
        this.showToast(res.message, 'error');
      } else {
        console.log("res.items", res);

        const productItem = res.items.find(_item => _item.id == variantId);

        console.log("res.items", res.items);

        button.classList.remove('loading');

        this.showToast(`${productItem.title} added to cart`);
      }

    } catch (error) {
      this.showToast('Failed to add item to cart', 'error');
      throw error;
    }
  }

  showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.className = `bb-toast ${type}`;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, this.toastTimeout);
  }
}

window.commonCart = new CommonCart(); 